import getFetchOptions from 'utils/getFetchOptions';

import {ENDPOINT_URL} from 'constants/index';

export default function upsertTestInfo(infoPatch) {
	console.log('This is the infor patch', infoPatch);
	return fetch(
		`${ENDPOINT_URL}/testdevice/info`,
		getFetchOptions({
			method: 'PATCH',
			body: JSON.stringify({infoPatch}),
		})
	);
}
